import { defineRecipe, defineStyle } from '@chakra-ui/react'

const common = {
    backgroundColor: 'blue.600',
    fontSize: '11px',
    fontFamily: 'GSKPrecision-Light',
    fontWeight: '300',
    textAlign: 'center',
    height: '20px',
    lineHeight: '20px',
    color: 'white',
}

const small = defineStyle({
    ...common,
    width: '20px',
    borderRadius: '50%',
})

const medium = defineStyle({
    ...common,
    width: '28px',
    borderRadius: '24px',
})

const large = defineStyle({
    ...common,
    width: '38px',
    borderRadius: '28px',
})

export const badgeRecipe = defineRecipe({
    variants: {
        size: {
            sm: small,
            md: medium,
            lg: large,
        },
    },
})
